import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Tag from '@/components-latest/primitives/Tag'
import { textVariants } from '@/components-latest/primitives/Text'
import {
  resolveStoreBrand,
  STORE_BRAND_LABEL_KEYS
} from '@/ducks/orders/helpers/brand.helpers'

import Styles from './OrderBrandTag.module.scss'

interface IOrderBrandTagProps {
  brand?: string | null
}

const OrderBrandTag: React.FC<IOrderBrandTagProps> = ({ brand }) => {
  const { t } = useTranslation()
  const resolvedBrand = resolveStoreBrand(brand)

  return (
    <Tag
      className={clsx(
        Styles.brandTag,
        Styles[resolvedBrand],
        textVariants({ variant: 'nextBody', weight: 'semiBold' })
      )}
      data-testid={`order-brand-${resolvedBrand}`}>
      {t(STORE_BRAND_LABEL_KEYS[resolvedBrand])}
    </Tag>
  )
}

export default OrderBrandTag
